<template>
	<div>
		<v-dialog v-model="openD" max-width="500" persistent>
			<v-card>
				<v-card-title class="headline text-xs-center">Descargar facturación por prescripción</v-card-title>
				<v-card-text>
					<v-text-field
							label="Número prescripción"
							v-model="result.prescription"
							name="Número prescripción"
							v-validate="'required'"
							:error-messages="errors.collect('Número prescripción')"
					></v-text-field>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
							@click="close"
					>
						{{load ? 'Cerrar' : 'Cancelar'}}
					</v-btn>
					<v-btn
							color="primary"
							:loading="load"
							:disabled="load"
							@click="submit"
					>
						Descargar
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
export default {
    data: () => ({
        openD: false,
        load: false,
		result: {
            prescription:null
		}
	}),
	methods: {
  	    submit () {
            this.$validator.validateAll().then(result => {
                if (result) {
                    this.$store.commit('snackbar', {color: 'warning', message: `Se está procesando la descarga de facturación.`})
                    this.$emit('onProcessing', true)
                    this.load = true
                    this.axios.get(`facturacionXPrescripcion?NoPrescripcion=${this.result.prescription}`)
                        .then(response => {
                            this.$emit('onProcessing', false)
                            this.$emit('onSuccess')
                            this.close()
                            this.$store.commit('reloadTable', 'tableFacturacion')
                            this.$store.commit('snackbar', {color: 'success', message: `Se han descargado ${response.data.length} registro${response.data.length === 1 ? '' : 's'} de facturación`})
                            this.load = false
                        }).catch(e => {
                        this.$emit('onProcessing', false)
                        this.$emit('onSuccess', false)
                        this.load = false
                        this.$store.commit('snackbar', {color: 'error', message: `al descargar los registros de facturación`, error: e})
                    })
				}
            })
		},
		open () {
		  this.openD = true
		},
		loading (val = true) {
		  this.load = val
		},
		close () {
		  	this.openD = false
			setTimeout(() => {
                this.load = false
                this.result.prescription = null
                this.$validator.reset()
			}, 400)
		}
  	}
}
</script>

